export const USDC_E_CONTRACT_ADDRESS = '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174' as const

// Native USDC on Polygon (Circle's native implementation)
export const USDC_NATIVE_CONTRACT_ADDRESS = '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359' as const

export const USDC_E_DECIMALS = 6
export const USDC_DECIMALS = 6

export const CTF_CONTRACT_ADDRESS = '0x4d97dcd97ec945f40cf65f87097ace5ea0476045' as const

export const CTF_EXCHANGE_ADDRESS = '0x4bFb41d5B3570DeFd03C39a9A4D8dE6Bd8B8982E' as const

export const NEG_RISK_CTF_EXCHANGE_ADDRESS = '0xC5d563A36AE78145C45a50134d48A1215220f80a' as const

export const NEG_RISK_ADAPTER_ADDRESS = '0xd91E80cF2E7be2e162c6513ceD06f1dD0dA35296' as const

// Treasury wallet for platform fees - configured via environment variable
// Falls back to a safe default (null address) if not set, which disables fees
export const TREASURY_WALLET_ADDRESS = (process.env.NEXT_PUBLIC_TREASURY_WALLET_ADDRESS ||
	'0x0000000000000000000000000000000000000000') as `0x${string}`

// Platform fee configuration
// TODO: TEMPORARY OVERRIDE — 0% fees for everyone. Restore to 0.0025 for 0.25% fee.
export const DEFAULT_FEE_RATE = 0
/** @deprecated Use DEFAULT_FEE_RATE and user-specific rates instead */
export const PLATFORM_FEE_PERCENT = DEFAULT_FEE_RATE
